"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var convertChart_1 = require("./convertChart");
var getFonts_1 = require("./getFonts");
var returnLine = "\n";
var convertCharFont = function (fonts, s) {
    for (var i = 0; i < fonts.length; i++) {
        var font = fonts[i];
        var newChar = convertChart_1.convertChar(s, font, true);
        if (s[0] !== returnLine && newChar !== s[0]) {
            return { newChar: newChar, font: font.name };
        }
    }
    return { newChar: s[0], font: null };
};
var jumpTwo = [
    'bold',
    'italic',
    'boldItalic',
    'scriptItalic',
    'scriptBold',
    'fraktur',
    'boldFraktur',
    'doubleStruck',
    'sansSerif',
    'sansSerifBold',
    'sansSerifItalic',
    'sansSerifBoldItalic',
    'monospace',
    'squaredCapital',
    'negativeCircledCapital',
    'negativeSquaredCapital',
    'regionalIndicatorSymbol',
    'parenthesized',
];
var parentesisExceptions = '⑴⑵⑶⑷⑸⑹⑺⑹⑻⑼';
function revertTransform(s, join) {
    if (join === void 0) { join = -1; }
    var fonts = Object.values(getFonts_1.getFonts());
    var output = [];
    for (var i = 0; i < s.length; i++) {
        var _a = convertCharFont(fonts, s.slice(i, i + 4 <= s.length ? i + 4 : s.length)), newChar = _a.newChar, font = _a.font;
        if (s[i] !== newChar && font) {
            output.push(newChar);
            if (jumpTwo.includes(font) && !parentesisExceptions.includes(s[i])) {
                i++;
            }
        }
        else {
            output.push(s[i]);
        }
    }
    return output.join(join < 0 ? '' : String.fromCodePoint(join)).toLowerCase();
}
exports.revertTransform = revertTransform;
//# sourceMappingURL=revert.js.map